import QueryBoundaries from '@/shared/components/QueryBoundaries';
import useOfferStatusPolling from './useOfferStatusPolling';

const OfferStatusPollingCaller = () => {
  useOfferStatusPolling();
  return null;
};

export const OfferStatusPolling = () => (
  <QueryBoundaries ErrorComponent={() => <></>}>
    <OfferStatusPollingCaller />
  </QueryBoundaries>
);

export default OfferStatusPolling;
